import React from 'react';
import { Container, Card, Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Home.css';

const Home: React.FC = () => {
  const heroImages = [
    { src: '/images/slider/10.jpg' },
    { src: '/images/slider/11.jpg' },
    { src: '/images/slider/12.jpg' },
    { src: '/images/slider/3.jpg' },
    { src: '/images/slider/4.jpg' },
    { src: '/images/slider/5.jpg' },
    { src: '/images/slider/6.jpg' },
    { src: '/images/slider/7.jpg' },
    { src: '/images/slider/8.jpg' },
    { src: '/images/slider/9.jpg' }
  ];

  const reviews = [
    {
      text:
        'Focení s paní Ivankou jsme si nesmírně užili. Je velmi vtipná, má spoustu nápadů a nervozita a strach z focení nás díky jejímu přístupu velmi rychle opustil. Navíc výsledek naprosto předčil naše očekávání. S fotečkami jsme velmi spokojeni a těšíme se na nějaké další focení.',
      author: 'Míša a Michal',
    },
    {
      text:
        'Ivi, ty tvoje fotky nemají chybu! Už jsme se na ně dívali několikrát a nemůžeme se od toho odtrhnout. Celá rodina se dívá na fotky ze svatby a všichni jsme se shodli na tom, že tak krásné fotky jsme ještě neviděli. Moc ti za ně ze srdce děkujeme. Jsi nejlepší!',
      author: 'Lucka a Rasťo',
    },
    {
      text:
        'Ivanko, ty jsi kouzelník. To není možné, co jsi dokázala všechno krásně zachytit. Spousta detailů mi ze svatby uteklo a díky tvým fotečkám, je mám zachycené. Jsem moc ráda, že jsme si vybrali zrovna tebe a že jsi s námi prožila celý svatební den.',
      author: 'Zdiška a Vašek',
    },
    {
      text:
        'Iva má opravdovou schopnost vtisknout do snímku náladu, příběh a často i jemný humor. Ať už fotí lidi, místa nebo detaily, vždy dokáže přimět diváka zastavit se a dívat se o pár vteřin déle, než je dnes běžné. To nejcennější je ale atmosféra, kterou kolem focení vytváří. I lidé, kteří tvrdí, že „na fotkách nevypadají dobře“, odcházejí s pocitem, že se dívali sami na sebe tak, jak by si přáli být viděni.',
      author: 'Laďka B.',
    },
    {
      text:
        'Svatební focení s Ivčou bylo skvělé. Nafotila nám krásné a přirozené svatební fotky, cítili jsme se s ní moc dobře a veškerá spolupráce se nesla v přátelském duchu. Využili jsme také možnosti předsvatebního focení, které moc doporučujeme. Určitě jsme s Ivkou nefotili naposledy.',
      author: 'Míša a Lukáš',
    },
  ];

  return (
    <div className="home">
      {/* === HERO SECTION === */}
      <section className="hero-section">
        <div className="hero-bg">
          <Carousel
            controls={false}
            indicators
            interval={4000}
            fade
            pause={false}
            className="hero-bg-carousel"
          >
            {heroImages.map((img) => (
              <Carousel.Item key={img.src} className="hero-bg-item">
                <img
                  src={img.src}
                  alt="Hero background"
                  className="hero-bg-img"
                  loading="eager"
                  decoding="async"
                />
              </Carousel.Item>
            ))}
          </Carousel>
        </div>

        <Container className="hero-center">
          <motion.div
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-content"
          >
            <h1 className="hero-title">
              Zachycené <span className="highlight">momenty</span> na celý život
            </h1>
            <p className="hero-subtitle">
              Profesionální fotografka pro vaše nejdůležitější okamžiky v životě.<br />
              Svatby, portréty, události – vytvořím pro vás nezapomenutelné vzpomínky.
            </p>
            <div className="hero-buttons">
              <Link to="/contact" className="btn btn-primary btn-lg me-3">Napište mi</Link>
              <Link to="/gallery" className="btn btn-outline-light btn-lg me-3">Ukázka práce</Link>
              {/* 🔔 NOVÉ TLAČÍTKO */}
              <Link to="/christmas" className="btn btn-primary btn-lg me-3">
                Vánoční focení
              </Link>
            </div>
          </motion.div>
        </Container>
      </section>

      {/* === REVIEWS SECTION === */}
      <section className="reviews-section py-5">
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-5"
          >
            <h2 className="section-title">Vaše recenze</h2>
            <p className="section-subtitle">
              Děkuji vám za všechna milá slova, která jste mi po každém focení napsali.
            </p>
          </motion.div>

          <div className="row">
            {reviews.map((review, i) => {
              const isLast = i === reviews.length - 1;
              const colClass = isLast
                ? 'col-12 col-md-10 col-lg-8 mx-auto mb-4 d-flex'
                : 'col-lg-6 mb-4 d-flex';

              return (
                <div className={colClass} key={i}>
                  <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: i * 0.1 }}
                    viewport={{ once: true }}
                    className="flex-fill"
                  >
                    <Card className="review-card h-100">
                      <Card.Body className="d-flex flex-column">
                        <Card.Text className="review-text flex-grow-1">
                          "{review.text}"
                        </Card.Text>
                        <Card.Title className="review-author mb-0">
                          – {review.author}
                        </Card.Title>
                      </Card.Body>
                    </Card>
                  </motion.div>
                </div>
              );
            })}
          </div>
        </Container>
      </section>
    </div>
  );
};

export default Home;